var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.053 28a.984.984 0 01-.7-.294 1.011 1.011 0 010-1.421l6.174-6.252-6.235-6.318a1.011 1.011 0 010-1.421.982.982 0 011.401 0l7.64 7.739-7.58 7.673a.986.986 0 01-.7.294z",
    id: "icon-arrowRight_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "#E6E6E6",
    fill: "#FFF",
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#0A3F46",
    xlinkHref: "#icon-arrowRight_svg__a"
  }))));
}

export default SvgIconArrowRight;